import { FilterCategory, SearchFilterBase, SearchFilterType } from '../types';

const SOCIAL_PLATFORMS = [
  {
    label: 'LinkedIn',
    value: 'linkedin',
    enabled: true,
    open: true,
  },
  {
    label: 'Facebook',
    value: 'facebook',
    enabled: false,
    open: false,
  },
  {
    label: 'X (Twitter)',
    value: 'twitter',
    enabled: false,
    open: false,
  },
  {
    label: 'Instagram',
    value: 'instagram',
    enabled: false,
    open: false,
  },
];

export default function socialMediaFollowersFilterConfig(): SearchFilterBase {
  return {
    comingSoon: true,
    disabled: true,
    name: 'Social Media Followers',
    icon: 'subscriptions',
    index: 23,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.CONTACT_DATA],
    pinned: false,
    items: [
      {
        name: '',
        type: SearchFilterType.BUTTON_GROUP,
        index: 0,
        key: 'social_media_platform',
        field: 'social_media_platform',
        config: { labelKey: 'label', valueKey: 'value' },
        items: SOCIAL_PLATFORMS.map((platform, idx) => ({
          name: platform.label,
          type: SearchFilterType.NONE,
          index: idx,
          key: platform.value,
          field: platform.value,
          comingSoon: !platform.enabled,
          disabled: !platform.enabled,
          open: platform.open,
          items: [],
        })),
      },
      {
        name: '',
        type: SearchFilterType.BUTTON_GROUP,
        index: 1,
        key: 'followers_connections_group',
        field: 'followers_connections_group',
        config: { labelKey: 'label', valueKey: 'value' },
        items: [
          {
            name: 'Applied Filters',
            type: SearchFilterType.APPLIED_FILTERS,
            index: 2,
            key: 'social_media_followers_applied_filters',
            field: 'social_media_followers_applied_filters',
            metadata: {},
          },
          {
            name: 'Followers',
            type: SearchFilterType.NONE,
            index: 1,
            key: 'followers',
            field: 'followers',
            open: true,
            utils: {
              tags: {
                config: {
                  showAsCard: true,
                  tagsCardTitle: 'Followers',
                },
              },
            },
            items: [
              {
                name: '',
                type: SearchFilterType.RADIO_GROUP,
                index: 0,
                key: 'followers_range_type',
                field: 'followers_range_type',
                sections: { main: 2, more: 1 },
                items: [
                  {
                    name: 'Predefined Range',
                    type: SearchFilterType.CHECK_BOX,
                    index: 0,
                    layer: 4,
                    key: 'followers_predefined',
                    field: 'followers_predefined',
                    options: [],
                    open: true,
                    nested: true,
                  },
                  {
                    name: 'Custom Range',
                    type: SearchFilterType.NUMBER_RANGE,
                    index: 1,
                    layer: 4,
                    key: 'followers_custom',
                    field: 'followers_custom',
                    metadata: {
                      color: 'primary',
                    },
                    nested: true,
                  },
                  {
                    name: 'LinkedIn Followers N/A',
                    type: SearchFilterType.NOT_AVAILABLE,
                    icon: undefined,
                    index: 2,
                    layer: 4,
                    key: 'linkedin_followers_availability',
                    field: 'linkedin_followers_availability',
                    metadata: { color: 'primary' },
                    nested: true,
                  },
                ],
              },
            ],
          },
          {
            name: 'Connections',
            type: SearchFilterType.NONE,
            index: 2,
            key: 'connections',
            field: 'connections',
            open: false,
            utils: {
              tags: {
                config: {
                  showAsCard: true,
                  tagsCardTitle: 'Connections',
                },
              },
            },
            items: [
              {
                name: '',
                type: SearchFilterType.RADIO_GROUP,
                index: 0,
                key: 'connections_range_type',
                field: 'connections_range_type',
                sections: { main: 2, more: 1 },
                items: [
                  {
                    name: 'Predefined Range',
                    type: SearchFilterType.CHECK_BOX,
                    index: 0,
                    layer: 4,
                    key: 'connections_predefined',
                    field: 'connections_predefined',
                    options: [],
                    open: true,
                    nested: true,
                  },
                  {
                    name: 'Custom Range',
                    type: SearchFilterType.NUMBER_RANGE,
                    index: 1,
                    layer: 4,
                    key: 'connections_custom',
                    field: 'connections_custom',
                    metadata: {
                      color: 'primary',
                    },
                    nested: true,
                  },
                  {
                    name: 'LinkedIn Connections N/A',
                    type: SearchFilterType.NOT_AVAILABLE,
                    icon: undefined,
                    index: 2,
                    layer: 4,
                    key: 'linkedin_connections_availability',
                    field: 'linkedin_connections_availability',
                    metadata: { color: 'primary' },
                    nested: true,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  };
}
